import { useState, useEffect } from 'react'
import useSession from 'querys/session'
import { useQueryClient, useMutation } from 'react-query'
import {
  updateProfileService,
  updatePasswordService,
  createPasswordService,
  updateConfigService,
  unlinkGithubService,
  unlinkDiscordService,
} from 'services/profile'

export function useUpdatePassword() {
  const { token } = useSession()
  return useMutation(
    (payload) => updatePasswordService({ token, payload }),
  )
}

export function useCreatePassword() {
  const { token } = useSession()
  return useMutation(
    (payload) => createPasswordService({ token, payload }),
  )
}

export function useCompleteAccount() {
  const { token } = useSession()
  return useMutation(
    (payload) => updateProfileService({ token, payload }),
  )
}

export function useUpdateProfile(setEdit) {
  const [error, setError] = useState('')
  const queryClient = useQueryClient()
  const [success, setSuccess] = useState(false)
  const { token } = useSession()
  const restoreProfile = () => {
    setTimeout(() => {
      setError('')
      setSuccess(false)
      setEdit(false)
    }, 4000)
  }
  const removeError = () => {
    setTimeout(() => {
      setError('')
    }, 4000)
  }
  useEffect(() => {
    if (error) {
      removeError()
    }
  }, [error])
  const mutation = useMutation(
    (payload) => updateProfileService({ token, payload }),
    {
      onError: () => {
        setError('Ocurrio un error al actualizar tu perfil')
        restoreProfile()
      },
      onSuccess: (newProfile) => {
        setError('')
        setSuccess(true)
        queryClient.setQueryData('GET_PROFILE', (profile) => {
          const {
            email, first_name, has_password, last_name, photo, username,
          } = newProfile
          return {
            ...profile, email, first_name, has_password, last_name, photo, username,
          }
        })
        restoreProfile()
      },
    },
  )
  return {
    ...mutation,
    error,
    success,
    setError,
  }
}

export function useUpdateConfig() {
  const { token } = useSession()
  const queryClient = useQueryClient()
  return useMutation(
    (payload) => updateConfigService({ token, payload }),
    {
      onSuccess: (payload) => {
        queryClient.setQueryData('GET_PROFILE', (profile) => ({
          ...profile, info: payload,
        }))
      },
    },
  )
}

export function useUnlinkGithub() {
  const { token } = useSession()
  const queryClient = useQueryClient()
  return useMutation(
    () => unlinkGithubService({ token }),
    {
      onSuccess: (payload) => {
        queryClient.setQueryData('GET_PROFILE', (profile) => ({
          ...profile,
          info: {
            ...profile.info,
            github_token: '',
            github_usename: '',
          },
        }))
      },
    },
  )
}

export function useUnlinkDiscord() {
  const { token } = useSession()
  const queryClient = useQueryClient()
  return useMutation(
    () => unlinkDiscordService({ token }),
    {
      onSuccess: (payload) => {
        queryClient.setQueryData('GET_PROFILE', (profile) => ({
          ...profile,
          info: {
            ...profile.info,
            discord_username: '',
          },
        }))
      },
    },
  )
}
